import { useQuery } from 'react-query'
import { fetchWrapper } from 'src/utils/fetchWrapper'
import type { WorkDone } from 'src/types/manageWorkOrder'

export function useWorkDone(itemId: number) {
  const API_ENDPOINT = `/workorders/${itemId}/items`
  return useQuery('workDone', async () => {
    return await fetchWrapper<WorkDone[]>({
      method: 'GET',
      url: API_ENDPOINT,
    })
  })
}
